


export const config = {
    baseURL:"https://api.wavelydx.com"
}

export const logOutDelayMilliseconds = 15 * 60 * 1000;

export const nonprod_aws_cognito_config = {
    Auth: {
        Cognito: {
            userPoolId: "us-west-2_9HfUpMFsh",
            userPoolClientId: "3h0u9t5u56fltpa7r2rfgiqr1s",
            loginWith: {
                email: true,
            },
            signUpVerificationMethod: "code",
            userAttributes: {
                email: {
                    required: true,
                },
            },
            allowGuestAccess: true,
            passwordFormat: {
                minLength: 8,
                requireLowercase: true,
                requireUppercase: true,
                requireNumbers: true,
                requireSpecialCharacters: true,
            },
        },
    },
}